import React from "react";
import {withStyles, WithStyles } from "@material-ui/core";
import styles from './styles';

export default withStyles(styles)((props: React.PropsWithChildren<WithStyles<typeof styles>>) => (
    <div className={props.classes.toolbar}>
        {props.children}
    </div>
));